import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { BaseDialog } from '@components/dialogs/base-dialog.';
import { DialogCardComponent } from '@components/ui/dialog-card/dialog-card.component';
import { ButtonDirective } from '@directives/button.directive';
import { TemplateDirective } from '@directives/template.directive';
import { environment } from '@env/environment';
import {
    NotificationActionEnum,
    NotificationModel,
    NotificationTypeEnum,
} from '@models/notification.model';
import { SvgIconComponent } from 'angular-svg-icon';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'pn-notification-detail-dialog',
    standalone: true,
    imports: [
        DialogCardComponent,
        CommonModule,
        ButtonDirective,
        SvgIconComponent,
        TemplateDirective,
    ],
    templateUrl: './notification-detail-dialog.component.html',
    styleUrl: './notification-detail-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationDetailDialogComponent extends BaseDialog<NotificationModel> {
    public notificationTypeEnum = NotificationTypeEnum;

    constructor(
        private readonly _domSanitizer: DomSanitizer,
        private readonly _router: Router,
        private readonly _cookieService: CookieService
    ) {
        super();
    }

    /**
     * Get content of notification
     *
     * @readonly
     * @type {*}
     * @memberof NotificationDetailDialogComponent
     * */
    public get content() {
        return this._domSanitizer.bypassSecurityTrustHtml(this.data.Content);
    }

    /**
     * Condition show interact button
     *
     * @param {NotificationModel} item
     * @return {*}  {boolean}
     * @memberof NotificationDetailDialogComponent
     */
    public get isShowInteract(): boolean {
        const isInteractOrderDetail = [
            NotificationActionEnum.OrderDetail,
            NotificationActionEnum.CreateOrder,
        ].includes(this.data.Action as NotificationActionEnum);

        return (
            isInteractOrderDetail &&
            this.data.TypeNotification === NotificationTypeEnum.Interact &&
            !!this.data.Data?.TransactionId
        );
    }

    /**
     * Interact with notification
     *
     * @return {*}
     * @memberof NotificationDetailDialogComponent
     */
    public interactNotification(): void {
        const { Data } = this.data;
        if (Data?.TransactionId) {
            const hasCookie = this._cookieService.check(environment.cookieName);
            this.close();
            if (hasCookie) {
                this._router.navigate(['/account/orders', Data.TransactionId]);
                return;
            }

            this._router.navigate(['/search-order/', Data.TransactionId]);
        }
    }
}
